import { render, staticRenderFns } from "./onlineSeminarsSettings.vue?vue&type=template&id=74e3e572&"
import script from "./onlineSeminarsSettings.vue?vue&type=script&lang=js&"
export * from "./onlineSeminarsSettings.vue?vue&type=script&lang=js&"
import style0 from "./onlineSeminarsSettings.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports